import React, { useReducer, useState } from 'react';

const CartContext = React.createContext();

// const initState = [];

const noItemsInCart = (cart) => {
    return !(cart.items && cart.items.length > 0);
}

const cartReducer = (cart, action) => {
    let newCart = cart;
    switch (action.type) {
        case 'addItem':
            let isNewItem = true;
            const currentItem = action.payload;
            let newCartItems = noItemsInCart(cart) ? [] : cart.items.map(item => {
                if (item.id === currentItem.id) {
                    isNewItem = false;
                    return currentItem;
                } else {
                    return item;
                }
            })
            if (isNewItem) {
                newCartItems.push(currentItem);
            }
            newCart.items = newCartItems;
            return newCart;
            // return isNewItem ? [...newCart, currentItem] : newCart;
        case 'removeItem':
            if (noItemsInCart(cart)) {
                return [];
            }
            const remainingItems = cart.items.filter((newItem) => newItem.id !== action.payload.id);
            newCart.items = remainingItems;
            return newCart;
            // return cart.filter((newItem) => newItem.id !== action.payload.id);
        case 'clearCart':
            return [];
        case 'getItems':
            return cart;
        case 'loadOrderIntoCart':
            const orderItems = action.payload.items;
            const loadedCartItems = orderItems.map(item => {
                return {
                    id: item.id,
                    product_id: item.id,
                    sku: item.sku,
                    name: item.name,
                    fullName: item.fullName,
                    price: item.price,
                    quantity: item.quantity,
                    // total: item.total
                }
            });
            newCart.items = loadedCartItems;
            newCart.shippings = action.payload.shippings;
            newCart.fees = action.payload.fees;
            return newCart;
        default:
            return cart;
    }
};

const CartProvider = ({ children }) => {
    const [cart, dispatch] = useReducer(cartReducer, []);
    const [keepCart, setKeepCart] = useState(false);

    const setItem = (item) => {
        dispatch({ type: 'addItem', payload: item });
    };

    const removeItem = (item) => {
        dispatch({ type: 'removeItem', payload: item });
    };
    
    const clearCart = () => {
        dispatch({ type: 'clearCart' });
    }
    
    const getItems = () => {
        dispatch({ type: 'getItems' });
    };

    const loadOrderIntoCart = (orderItems) => {
        dispatch({ type: 'loadOrderIntoCart', payload: orderItems})
    }

    const emptyCart = () => {
        return noItemsInCart(cart);
    }

    const inCart = (productId) => {
        if (!emptyCart()) {
            for (cartProduct of cart.items) {
                if (cartProduct.id === productId) {
                    return cartProduct.quantity;
                }    
            }
        }
        return 0;
    }

    const getCartTotal = () => {
        const itemsTotal = cart.items ? cart.items.reduce((acum, item) => acum + item.quantity * item.price, 0) : 0;
        const shippingsTotal = cart.shippings ? cart.shippings.reduce((acum, item) => acum + item.quantity * item.price, 0) : 0;
        const feesTotal = cart.fees ? cart.fees.reduce((acum, item) => acum + item.quantity * item.price, 0) : 0;
        
        return itemsTotal + shippingsTotal + feesTotal;
    }
    
    return (
        <CartContext.Provider value={{ cart, setItem, removeItem, clearCart, getItems, loadOrderIntoCart, emptyCart, inCart, getCartTotal, keepCart, setKeepCart }}>
            {children}
        </CartContext.Provider>
    );
};

export { CartContext, CartProvider };

